__turbopack_context__.v({
  "className": "_0VE64q_className",
  "variable": "_0VE64q_variable",
});
